import { render, staticRenderFns } from "./MemberProjectList.vue?vue&type=template&id=47a47db6&scoped=true"
import script from "./MemberProjectList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberProjectList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MemberProjectList.vue?vue&type=style&index=0&id=47a47db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a47db6",
  null
  
)

export default component.exports